import React from 'react';
import { Card, CardContent, Typography, Box, Chip, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { CheckCircle as CheckIcon } from '@mui/icons-material';
import LandingCtaButton from './LandingCtaButton';
import { LANDING_COLORS, LANDING_FONTS } from '../landingVisual';

const PathCard = ({ title, bullets, cta, popular = false }) => (
  <Card
    elevation={0}
    sx={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      fontFamily: LANDING_FONTS.sans,
      border: '1px solid',
      borderColor: popular ? LANDING_COLORS.accent : LANDING_COLORS.line,
      borderRadius: 2,
      boxShadow: popular ? '0 12px 40px rgba(15, 23, 42, 0.08)' : 'none',
      bgcolor: 'background.paper',
    }}
  >
    {popular && (
      <Chip
        label="Most Popular"
        size="small"
        sx={{
          position: 'absolute',
          top: 16,
          right: 16,
          bgcolor: LANDING_COLORS.ink,
          color: '#fff',
          fontWeight: 600,
          fontFamily: LANDING_FONTS.sans,
          borderRadius: 1,
        }}
      />
    )}
    <CardContent sx={{ p: 3, flex: 1, display: 'flex', flexDirection: 'column' }}>
      <Typography
        variant="h5"
        component="h3"
        sx={{
          fontFamily: LANDING_FONTS.sans,
          fontWeight: 700,
          letterSpacing: '-0.02em',
          mb: 2,
          pr: popular ? 10 : 0,
        }}
      >
        {title}
      </Typography>
      <List dense disablePadding sx={{ mb: 3, flex: 1 }}>
        {bullets.map((item) => (
          <ListItem key={item} disableGutters sx={{ py: 0.5 }}>
            <ListItemIcon sx={{ minWidth: 32 }}>
              <CheckIcon sx={{ fontSize: 20, color: LANDING_COLORS.accent }} />
            </ListItemIcon>
            <ListItemText
              primary={item}
              primaryTypographyProps={{
                variant: 'body2',
                sx: { fontFamily: LANDING_FONTS.sans, lineHeight: 1.6 },
              }}
            />
          </ListItem>
        ))}
      </List>
      <Box>
        <LandingCtaButton to={cta.to} label={cta.label} variant={cta.variant} fullWidth />
      </Box>
    </CardContent>
  </Card>
);

export default PathCard;
